import React, { useState } from 'react';
import { Tabs, Tab, Box, Grid, Card } from '@mui/material';
import { styled } from '@mui/system';
import SoftTypography from "components/SoftTypography";
import './style.css';

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: 0,
  padding: '12px 16px',
  margin: '0 4px',
  backgroundColor: 'transparent',
  fontWeight: 600,
  borderBottom: '3px solid transparent',
  boxShadow: 'none',
  color: '#717171 !important',
  transition: 'background-color 0.3s, color 0.3s, font-weight 0.3s, border-bottom 0.3s',
  '&.Mui-selected': {
    backgroundColor: 'transparent',
    color: '#181A20 !important',
    fontWeight: 600,
    borderBottom: '3px solid #181A20',
    boxShadow: 'none',  // Ensure boxShadow is 'none' in the selected state
  },
  '&:hover': {
    backgroundColor: 'transparent',
    color: '#181A20 !important',
    borderBottom: 'none',
    borderBottom: '3px solid #181A20',
  },
}));

const CustomTabs = ({ tabsData }) => {
  const [activeTab, setActiveTab] = useState(0);

  // Modify handleChange to prevent interaction with disabled tabs
  const handleChange = (index, disabled) => {
    if (!disabled) {
      setActiveTab(index);
    }
  };

  return (
    <Card
      sx={{
        padding: '20px 40px',
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
      }}
    >
      <div className="tabs-container">
        <div className="tabs-header">
          {tabsData?.map((tab, index) => (
            <div
              key={index}
              style={{ fontFamily: "inter" }}
              className={`tab ${activeTab === index ? 'tab-active' : ''} ${tab.disabled ? 'tab-disabled' : ''}`} // Add tab-disabled class
              onClick={() => handleChange(index, tab.disabled)}  // Pass the disabled state to handleChange
            >
              {index + 1}. {tab.label}
            </div>
          ))}
        </div>
        {tabsData?.map((tab, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? 'tab-content-active' : ''}`}
          >
            <SoftTypography>{tab.content}</SoftTypography>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CustomTabs;